import React, { useState, useEffect, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useActivate, useUnactivate } from 'react-activation';

import styles from './index.module.scss';
import { fridayAgent, usePageView } from '@cvte/react-fridayagent3';
import FRIDAYAGENT_EVENTS from 'constant/fridayAgentEvent';
import { useScheduleContext } from 'page/MeetingSchedule/Provider/ScheduleProvider';
import TopBar from '../TopBar';
import { CurrentMode } from 'page/MeetingSchedule/types/type';
import CalendarView from '../CalendarView';
import ScheduleView from '../ScheduleView';
import qs from 'qs';
import moment from 'moment';

interface IProps {}

const ContainerView: React.FC<IProps> = () => {
  const { scheduleDispatch, originState } = useScheduleContext();
  const { currentMode } = originState;

  const [binkTime, setbinkTime] = useState<any>();

  // 埋点 KeepAlive 组件 页面曝光
  // 埋点 KeepAlive组件 记录页面停留时长

  usePageView({ ...FRIDAYAGENT_EVENTS.WEB_TEAMS_PAGEVIEW_SCHEDULE });
  let start = Date.now();
  useActivate(() => {
    start = Date.now();
    fridayAgent.pushData({ ...FRIDAYAGENT_EVENTS.WEB_TEAMS_PAGEVIEW_SCHEDULE });
  });
  useUnactivate(() => {
    const end = Date.now();
    const duration = end - start;
    fridayAgent.pushData({ ...FRIDAYAGENT_EVENTS.WEB_TEAMS_TIMEONPAGE_SCHEDULE, data: { stay_duration: duration } });
  });

  useEffect(() => {
    const query = qs.parse(location.search.slice(1));
    if (query.targetTime) {
      setbinkTime(moment(Number(query.targetTime)));
      scheduleDispatch({
        type: 'SET_STATE',
        payload: {
          currentMode: CurrentMode.calendar
        }
      });
    }
  }, []);
  return (
    <div className={styles.wrap}>
      <TopBar binkTime={binkTime}></TopBar>
      {currentMode === CurrentMode.schedule && <ScheduleView></ScheduleView>}
      {currentMode === CurrentMode.calendar && <CalendarView binkTime={binkTime}></CalendarView>}
    </div>
  );
};
export default ContainerView;
